import { render } from "./PlayerInfo.vue?vue&type=template&id=1540b3dc"
import script from "./PlayerInfo.vue?vue&type=script&lang=js"
export * from "./PlayerInfo.vue?vue&type=script&lang=js"

import "./PlayerInfo.vue?vue&type=style&index=0&id=1540b3dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__